import React from 'react';
import { Modal } from '../../../app/common/sharedComponents/Modal';
import { ButtonBlockColumn } from './../../../app/common/sharedStyledComponents/GenericStyles.styled';
import { ModalContent } from '../../../app/common/sharedStyledComponents/Modal.styled';
import { Body4 } from '../../../app/common/typography';
import { ActionTextWrapper } from './styled.endSessionModal';
import { useTranslation } from 'react-i18next';
import { ButtonLarge } from '../../../app/common/sharedComponents/buttons/ButtonLarge';

const EndSessionModal = ({ isOpen, setIsOpen, onEndSession }) => {
  const { t } = useTranslation();
  return (
    <Modal isOpen={isOpen} handleModalClose={() => setIsOpen(false)}>
      <ModalContent>
        <Body4>
          {t(
            'COMMON.ALERT_MESSAGES.ALREADY_LOGGED_IN_MODAL.LOGGED_IN_ANOTHER_DEVICE_CHOOSE_TO_CONTINUE'
          )}
          <ActionTextWrapper>
            {` '${t('COMMON.OUTSIDE.BUTTONS.END_SESSION')}' `}
          </ActionTextWrapper>
          {t(
            'COMMON.ALERT_MESSAGES.ALREADY_LOGGED_IN_MODAL.TO_TERMINATE_ANOTHER_DEVICE_UNSAVED_WILL_BE_LOST_SELECT'
          )}
          <ActionTextWrapper>
            {` '${t('COMMON.OUTSIDE.BUTTONS.CANCEL')}' `}
          </ActionTextWrapper>
          {t(
            'COMMON.ALERT_MESSAGES.ALREADY_LOGGED_IN_MODAL.REMAIN_LOGGED_IN_CURRENT_DEVICE'
          )}
        </Body4>
      </ModalContent>
      <ButtonBlockColumn>
        <ButtonLarge
          title={t('COMMON.OUTSIDE.BUTTONS.END_SESSION')}
          onClick={(event) => {
            onEndSession(event);
            setIsOpen(false);
          }}
          backgroundColor="oxfordBlue"
        />
        <ButtonLarge
          title={t('COMMON.OUTSIDE.BUTTONS.CANCEL')}
          onClick={() => setIsOpen(false)}
          outlined={true}
          inverted={true}
        />
      </ButtonBlockColumn>
    </Modal>
  );
};

export default EndSessionModal;
